// extracted by mini-css-extract-plugin
export default {"container":"VfCUCg","icon":"gjRSzR","text":"MXTCxw"};